import React from 'react';
import { TextField } from 'material-ui';
import moment from 'moment';
import parseFormat from 'moment-parseformat';
import PropTypes from 'prop-types';
import { StyleSheet, css } from 'aphrodite';

import OurismanTravelTheme from '../ourismanTravelTheme';

export default class DateRange extends React.Component {
  static propTypes = {
    startValue: PropTypes.shape(),
    endValue: PropTypes.shape(),
    allowPast: PropTypes.bool,
    parseDate: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    startLabel: PropTypes.string.isRequired,
    endLabel: PropTypes.string.isRequired,
    className: PropTypes.string,
    fieldClass: PropTypes.string,
  }

  static defaultProps = {
    parseDate: true,
    allowPast: false,
    startValue: {},
    endValue: {},
    className: '',
    fieldClass: '',
  }

  constructor(props) {
    super(props);

    const { startValue, endValue } = this.props;
    const {
      parsedValue: parsedStart,
      errorText: startError,
    } = this.processValue(startValue);
    const {
      parsedValue: parsedEnd,
      errorText: endError,
    } = this.processValue(endValue);

    this.state = {
      startInput: startValue,
      endInput: endValue,
      parsedStart,
      parsedEnd,
      startError,
      endError: endValue ? endError : '',
      singleFieldEntry: false,
    };
  }

  onChangeStart = (e) => {
    const { target: { value } } = e;
    const { allowPast } = this.props;

    const dateStringRE = /(\d{1,2})(\w{3})[- ](\d+)[Nn][Tt] ?(\d{4})?/;
    const match = dateStringRE.exec(value);

    let { parsedStart, parsedEnd } = this.state;

    if (match) {
      const [, day, month, duration, year = moment().year()] = match;

      let startDate = moment(`${day} ${month} ${year}`, 'DD MMM YYYY');
      if (!allowPast && startDate < moment()) {
        startDate = moment(`${day} ${month} ${year + 1}`, 'DD MMM YYYY');
      }

      const endDate = moment(startDate).add(
        moment.duration(parseInt(duration, 10), 'days'));

      const startValues = this.processValue(startDate);
      const endValues = this.processValue(endDate);

      parsedStart = startValues.parsedValue;
      parsedEnd = endValues.parsedValue;

      this.setState({
        startInput: value.toUpperCase(),
        endInput: endValues.errorText,
        parsedStart,
        parsedEnd,
        startError: startValues.errorText,
        endError: '',
        singleFieldEntry: true,
      });
    } else {
      const processedValues = this.processValue(value);
      parsedStart = processedValues.parsedValue;

      this.setState({
        startInput: processedValues.input,
        parsedStart,
        startError: processedValues.errorText,
        singleFieldEntry: false,
      });
    }
    this.props.onChange({
      startDate: parsedStart,
      endDate: parsedEnd,
    });
  }

  onChangeEnd = (e) => {
    const { target: { value } } = e;
    const { parsedStart } = this.state;
    let { parsedEnd } = this.state;
    const processedValues = this.processValue(value);
    parsedEnd = processedValues.parsedValue;

    this.setState({
      endInput: processedValues.input,
      parsedEnd,
      endError: processedValues.errorText,
    });
    this.props.onChange({
      startDate: parsedStart,
      endDate: parsedEnd,
    });
  }

  componentWillReceiveProps(nextProps) {
    const { parseDate: nextParseDate, value: nextValue } = nextProps;
    const {
      onChange: passedOnChange,
      parseDate: currentParseDate,
      value: currentValue,
    } = this.props;

    if (currentValue && currentParseDate !== nextParseDate) {
      let nextState = {
        input: nextValue,
        parsedValue: '',
      };
      if (nextParseDate && nextValue) {
        nextState = this.processValue(nextValue);
      }

      if (this.state.parsedValue !== nextState.parsedValue) {
        this.setState(nextState);
        passedOnChange({ target: { value: nextValue } });
      }
    } else {
      this.setState({ input: nextValue });
    }
  }

  processValue = (value) => {
    if (value === undefined || value === '') {
      return {
        input: value,
        parsedValue: null,
        errorText: '',
      };
    }

    const format = 'dddd, MMMM Do YYYY';
    const { allowPast } = this.props;

    let parsedValue;
    if (moment.isMoment(value)) {
      parsedValue = value;
    } else {
      const enteredFormat = value ? parseFormat(value) : format;
      parsedValue = moment(value, enteredFormat);
      if (!allowPast && parsedValue < moment() && enteredFormat.search('Y') < 0) {
        parsedValue.add(1, 'years');
      }
    }

    return {
      input: value,
      parsedValue: parsedValue && parsedValue.isValid() ? parsedValue : null,
      errorText: parsedValue && parsedValue.isValid() ?
        parsedValue.format(format) : "can't interpret date",
    };
  }

  render() {
    const {
      startInput, endInput, startError, endError, singleFieldEntry,
      parsedStart, parsedEnd,
    } = this.state;
    const { startLabel, endLabel, className, fieldClass } = this.props;

    const startErrorStyle = {
      color: parsedStart && moment(parsedStart).isValid() ?
        OurismanTravelTheme.palette.primary1Color :
        OurismanTravelTheme.palette.accent2Color,
    };

    const endErrorStyle = {
      color: parsedEnd && moment(parsedEnd).isValid() ?
        OurismanTravelTheme.palette.primary1Color :
        OurismanTravelTheme.palette.accent2Color,
    };

    return (<div className={className || css(styles.componentStyle)}>
      <TextField
        className={css(styles.fieldStyle)}
        floatingLabelText={startLabel}
        value={startInput || ''}
        errorText={startError}
        onChange={this.onChangeStart}
        errorStyle={startErrorStyle}
        floatingLabelFocusStyle={startErrorStyle}
      />
      <TextField
        className={fieldClass || css(styles.fieldStyle)}
        floatingLabelText={endLabel}
        value={endInput || ''}
        errorText={endError}
        disabled={singleFieldEntry}
        onChange={this.onChangeEnd}
        errorStyle={endErrorStyle}
        floatingLabelFocusStyle={endErrorStyle}
      />
    </div>);
  }
}

const styles = StyleSheet.create({
  componentStyle: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  fieldStyle: {
    width: 256,
    marginRight: 24,
  },
});



// WEBPACK FOOTER //
// /src/components/DateRangeComponent.js